"use strict";

exports.__esModule = true;
exports.LANGUAGE_KEY = void 0;
var LANGUAGE_KEY = 'selected-lang';
exports.LANGUAGE_KEY = LANGUAGE_KEY;